import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "input", "description"];

  showInput(event) {
    event.currentTarget.classList.add("hidden");
    if (this.hasDescriptionTarget) {
      this.descriptionTarget.classList.add("hidden");
    }
    this.formTarget.classList.remove("hidden");
    this.inputTarget.focus();
  }

  hideInput(event) {
    event.currentTarget.classList.remove("hidden");
    if (this.hasDescriptionTarget) {
      this.descriptionTarget.classList.remove("hidden");
    }
    this.formTarget.classList.add("hidden");
  }
}
